var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1648_18482)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.28069 15.7612C1.57241 11.1005 4.19241 7.80737 8.01586 6.04116C9.1731 5.52254 10.5214 5.10806 11.9283 4.86254L12.0324 4.84737C12.351 4.84737 12.3524 4.83771 12.3524 2.53564V0.224609L20.2462 8.1184L12.3524 16.0122V11.3901H11.3924C8.87496 11.4437 6.40022 12.0512 4.14414 13.1694L4.24414 13.1246C3.02149 13.8331 1.91308 14.7224 0.956552 15.7625L0.947586 15.7729L0 16.7756L0.28069 15.7612Z",
    fill: "#E36156"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1648_18482"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 16.5517,
    fill: "white",
    transform: "translate(0 0.224609)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIcon);
export default __webpack_public_path__ + "static/media/share-icon.0f640ae6068f7f560b4a733223cedc34.svg";
export { ForwardRef as ReactComponent };